export default __webpack_public_path__ + "static/media/qlik-info-1.728de6f1.png";